import React, { useEffect, useState } from "react";
import CountUp from "react-countup";

import { Container } from "./styles";
import { toast } from "react-toastify";
import api from "../../../services/api";
import { useNavigate } from "react-router-dom";
import Status from "../../../components/status";
import {
  Card,
  HeaderTitle,
  Message,
  Table,
  ViewInput,
} from "../../../GlobalStyles";

import { getDate, getValue, phoneFormat } from "../../../services/functions";
import { addDays, format } from "date-fns";
import { Button, Pagination, Spin, DatePicker, Select, Modal } from "antd";
import locale from "antd/es/date-picker/locale/pt_BR";
import dayjs from "dayjs";
import { useQuery } from "../../../hooks/Location";
import { MdAccountBalance, MdClose, MdMail, MdPhone } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
import { ContainerLead, Label } from "../Leads/styles";

const PagamentosAdmin = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const [users, setUsers] = useState([]);
  const [payments, setPayments] = useState([]);
  const [totalValue, setTotalValue] = useState(0);
  const [paymentsTotal, setPaymentsTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [user_id, setUser_id] = useState(query.get("cliente") || "");
  const [status, setStatus] = useState("");
  const [method, setMethod] = useState("");
  const [type, setType] = useState("");
  const [startDate, setStartDate] = useState(addDays(new Date(), -30));
  const [endDate, setEndDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(true);

  const [visibleDepositModal, setVisibleDepositModal] = useState(false);
  const [selectedDeposit, setSelectedDeposit] = useState(null);
  const [visibleLeadModal, setVisibleLeadModal] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);

  useEffect(() => {
    loadPayments(page);
  }, [page]);

  useEffect(() => {
    loadUsers();
  }, []);

  async function loadLeadDetails(id) {
    setIsLoadingDetails(true);
    setSelectedLead(null);
    setVisibleLeadModal(true);
    await api
      .get(`/leadmaster/${id}`)
      .then((response) => {
        setSelectedLead(response.data);
      })
      .catch(({ response }) => {
        toast.error("Erro ao carregar dados do lead");
        setVisibleLeadModal(false);
      });
    setIsLoadingDetails(false);
  }

  async function loadDepositDetails(id) {
    setIsLoadingDetails(true);
    setSelectedDeposit(null);
    setVisibleDepositModal(true);
    await api
      .get(`/deposit/${id}`)
      .then((response) => {
        setSelectedDeposit(response.data);
      })
      .catch(({ response }) => {
        toast.error("Erro ao carregar dados do depósito");
        setVisibleDepositModal(false);
      });
    setIsLoadingDetails(false);
  }

  async function loadUsers() {
    await api
      .get(`/users/franqueado?all=true`)
      .then((response) => {
        setUsers(response.data.users);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function loadPayments(page) {
    setIsLoading(true);
    await api
      .get(`/admin/payments?page=${page}`)
      .then((response) => {
        setPayments(response.data.payments);
        setTotalValue(response.data.totalValue);
        setPaymentsTotal(response.data.paymentsTotal);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  return (
    <Container>
      <HeaderTitle>
        <h1>Todos Pagamentos</h1>
        <Button
          type="primary"
          style={{
            borderRadius: 50,
          }}
          onClick={() => {
            navigate("/admin/pacotes");
          }}
        >
          <MdAccountBalance size="20" color="#fff" />
          Pacotes de Deposito
        </Button>
      </HeaderTitle>

      {!isLoading && (
        <>
          <Card>
            <p>Total</p>
            <CountUp duration={1} end={paymentsTotal} />
          </Card>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              marginBottom: 20,
            }}
          >
            <ViewInput
              style={{ width: "100%", maxWidth: 265, marginRight: 15 }}
            >
              <p>Selecione o Periodo</p>
              <DatePicker.RangePicker
                placeholder={["data inicial", "data final"]}
                value={[
                  startDate ? dayjs(startDate) : "",
                  endDate ? dayjs(endDate) : "",
                ]}
                locale={locale}
                format={"DD/MM/YYYY"}
                onChange={(value, dateString) => {
                  setStartDate(getDate(dateString[0]));
                  setEndDate(getDate(dateString[1]));
                  setPage(0);
                }}
                allowClear={false}
                style={{ width: 265 }}
                onOk={() => {}}
              />
            </ViewInput>
            <ViewInput
              style={{ width: "100%", maxWidth: 200, marginRight: 15 }}
            >
              <p>Filtrar por Franqueado</p>
              <Select
                placeholder="selecionar franqueado"
                value={user_id}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setUser_id(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todos Franqueados</Select.Option>
                {users.map((item) => {
                  return (
                    <Select.Option value={item.id}>{item.name}</Select.Option>
                  );
                })}
              </Select>
            </ViewInput>
            <ViewInput
              style={{ width: "100%", maxWidth: 150, marginRight: 15 }}
            >
              <p>Filtrar por Status</p>
              <Select
                placeholder="selecionar status"
                value={status}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setStatus(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todos</Select.Option>
                <Select.Option value="pendente">Pendente</Select.Option>
                <Select.Option value="confirmado">Confirmado</Select.Option>
                <Select.Option value="cancelado">Cancelado</Select.Option>
              </Select>
            </ViewInput>
            <ViewInput
              style={{ width: "100%", maxWidth: 150, marginRight: 15 }}
            >
              <p>Filtrar por Método</p>
              <Select
                placeholder="selecionar status"
                value={method}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setMethod(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todos</Select.Option>
                <Select.Option value="PIX">PIX</Select.Option>
                <Select.Option value="SALDO">Saldo</Select.Option>
              </Select>
            </ViewInput>
            <ViewInput style={{ width: "100%", maxWidth: 175 }}>
              <p>Filtrar por Tipo</p>
              <Select
                placeholder="selecionar status"
                value={type}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setType(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todos</Select.Option>
                <Select.Option value="OS">Ordem de Serviço</Select.Option>
                <Select.Option value="LEAD">Compra de Lead</Select.Option>
                <Select.Option value="DEPOSIT">Deposito de Saldo</Select.Option>
              </Select>
            </ViewInput>
          </div>
          {!!totalValue && (
            <h4 style={{ marginTop: 0, marginBottom: -15 }}>
              {" "}
              {totalValue.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })}{" "}
              total em pagamentos
            </h4>
          )}
          {!!paymentsTotal ? (
            <Table>
              <thead>
                <tr>
                  <td>Tipo</td>
                  <td>Valor</td>
                  <td>Método</td>
                  <td>Status</td>
                  <td>Ultima atualização</td>
                </tr>
              </thead>
              <tbody>
                {payments.map((payment) => {
                  return (
                    <tr key={payment.id}>
                      <td
                        style={{
                          fontWeight: "800",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                      >
                        <Button
                          type="primary"
                          style={{ height: 25 }}
                          onClick={() => {
                            if (payment.type == "OS") {
                              navigate(`/admin/os/${payment.order_id}`);
                            } else if (payment.type == "LEAD") {
                              loadLeadDetails(payment.lead_id);
                            } else if (payment.type == "DEPOSIT") {
                              loadDepositDetails(payment.deposit_id);
                            }
                          }}
                        >
                          {payment.type == "OS"
                            ? `OS: ${payment.order_id}`
                            : payment.type == "LEAD"
                              ? `VER LEAD`
                              : "VER DEPOSITO"}
                        </Button>
                      </td>
                      <td style={{ textTransform: "capitalize" }}>
                        {(payment.value || 0).toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </td>
                      <td>{payment.method}</td>
                      <td
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Status
                          status={payment.status}
                          isPayment={true}
                          style={{
                            fontSize: 11,
                            height: 20,
                            paddingBottom: 2,
                          }}
                        />
                      </td>
                      <td>
                        {format(
                          new Date(payment.update_at),
                          "dd/MM/yyyy HH:mm",
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          ) : (
            <Message style={{ marginTop: 40 }}>
              Nenhum pagamento encontrado
            </Message>
          )}
        </>
      )}

      <Pagination
        style={{ marginTop: 15, alignSelf: "center" }}
        defaultCurrent={page + 1}
        onChange={(page) => {
          setPage(page - 1);
        }}
        total={paymentsTotal}
        pageSize={30}
      />

      <Modal
        title={"Detalhes do Depósito"}
        open={visibleDepositModal}
        onCancel={() => setVisibleDepositModal(false)}
        footer={[
          <Button key="back" onClick={() => setVisibleDepositModal(false)}>
            FECHAR
          </Button>,
        ]}
        width={500}
      >
        {isLoadingDetails ? (
          <div style={{ textAlign: "center", padding: "20px 0" }}>
            <Spin size="large" />
          </div>
        ) : (
          selectedDeposit && (
            <div style={{ padding: "10px 0" }}>
              <div style={{ marginBottom: 20 }}>
                <h3
                  style={{
                    borderBottom: "1px solid #eee",
                    paddingBottom: 5,
                    fontSize: 16,
                  }}
                >
                  Informações do Depósito
                </h3>
                <p style={{ margin: "5px 0" }}>
                  <strong>Nome:</strong> {selectedDeposit.name}
                </p>
                <p style={{ margin: "5px 0" }}>
                  <strong>Descrição:</strong>{" "}
                  {selectedDeposit.description || "Sem Descrição"}
                </p>
                <p style={{ margin: "5px 0" }}>
                  <strong>Valor:</strong> {getValue(selectedDeposit.value || 0)}
                </p>
                <p style={{ margin: "5px 0" }}>
                  <strong>Bônus:</strong> {getValue(selectedDeposit.bonus || 0)}
                </p>
                <p
                  style={{
                    margin: "5px 0",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <strong>Status:</strong>{" "}
                  <Status
                    status={selectedDeposit.status}
                    isPayment={true}
                    style={{
                      marginLeft: 10,
                      fontSize: 11,
                      height: 20,
                      paddingBottom: 2,
                    }}
                  />
                </p>
                <p style={{ margin: "5px 0" }}>
                  <strong>Data:</strong>{" "}
                  {format(
                    new Date(selectedDeposit.update_at),
                    "dd/MM/yyyy HH:mm",
                  )}
                </p>
              </div>
              <div>
                <h3
                  style={{
                    borderBottom: "1px solid #eee",
                    paddingBottom: 5,
                    fontSize: 16,
                  }}
                >
                  Informações do Usuário
                </h3>
                <p style={{ margin: "5px 0" }}>
                  <strong>Nome:</strong> {selectedDeposit.user.name}
                </p>
                <p style={{ margin: "5px 0" }}>
                  <strong>Email:</strong> {selectedDeposit.user.email}
                </p>
                <p style={{ margin: "5px 0" }}>
                  <strong>Telefone:</strong>{" "}
                  {selectedDeposit.user.phone_number
                    ? phoneFormat(selectedDeposit.user.phone_number)
                    : "Não informado"}
                </p>
              </div>
            </div>
          )
        )}
      </Modal>

      <Modal
        width={400}
        open={visibleLeadModal}
        onCancel={() => {
          setVisibleLeadModal(false);
        }}
        styles={{
          content: {
            padding: 0,
          },
        }}
        footer={<></>}
        closable={false}
      >
        {isLoadingDetails ? (
          <div style={{ textAlign: "center", padding: "50px 0" }}>
            <Spin size="large" />
          </div>
        ) : (
          selectedLead && (
            <ContainerLead style={{ borderTopWidth: 30, margin: 0 }}>
              <MdClose
                style={{
                  position: "absolute",
                  cursor: "pointer",
                  top: -25,
                  right: 10,
                }}
                size={20}
                color="#3a3a3a"
                onClick={() => setVisibleLeadModal(false)}
              />
              <header style={{ top: -20 }}>
                <Label color={"#008037"} />
                <p>Lead</p>
              </header>
              <p style={{ width: "calc(100% - 50px)" }}>{selectedLead.name}</p>
              {selectedLead.email && (
                <p style={{ fontSize: 12, color: "#0009" }}>
                  Email: {selectedLead.email}
                </p>
              )}
              {selectedLead.phone_number && (
                <p style={{ fontSize: 12, color: "#0009" }}>
                  Telefone: {selectedLead.phone_number}
                </p>
              )}
              {selectedLead.necessity && (
                <p style={{ fontSize: 12, color: "#0009" }}>
                  Necessidade: {selectedLead.necessity}
                </p>
              )}
              {selectedLead.employees && (
                <p style={{ fontSize: 12, color: "#0009" }}>
                  Funcionarios: {selectedLead.employees}
                </p>
              )}
              {selectedLead.cnpj && (
                <p style={{ fontSize: 12, color: "#0009" }}>
                  CNPJ: {selectedLead.cnpj}
                </p>
              )}
              {selectedLead.location && (
                <p style={{ fontSize: 12, color: "#0009" }}>
                  Localização: {selectedLead.location}
                </p>
              )}
              {selectedLead.observation && (
                <p style={{ fontSize: 12, color: "#0009", width: "85%" }}>
                  Observação: {selectedLead.observation}
                </p>
              )}
              <p style={{ marginBottom: 5 }}>
                {(selectedLead.value || 0).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })}
              </p>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  paddingBottom: 10,
                }}
              >
                <div style={{ display: "flex" }}>
                  {selectedLead.phone_number && (
                    <FaWhatsapp
                      onClick={() => {
                        window.open(
                          `https://api.whatsapp.com/send/?phone=55${selectedLead.phone_number}`,
                        );
                      }}
                      size={18}
                      color={"#0c0"}
                      style={{ margin: "0 4px 0 0", cursor: "pointer" }}
                    />
                  )}

                  {selectedLead.phone_number && (
                    <MdPhone
                      onClick={() => {
                        window.open(`tel:${selectedLead.phone_number}`);
                      }}
                      size={18}
                      style={{ margin: "0 4px", cursor: "pointer" }}
                    />
                  )}

                  {selectedLead.email && (
                    <MdMail
                      onClick={() => {
                        window.open(`mailto${selectedLead.email}`);
                      }}
                      size={20}
                      color={"#FAB833"}
                      style={{ margin: "0 4px", cursor: "pointer" }}
                    />
                  )}
                </div>
              </div>
            </ContainerLead>
          )
        )}
      </Modal>
    </Container>
  );
};

export default PagamentosAdmin;
